export const SET_PASSED_RF_QUIZ = 'SET_PASSED_RF_QUIZ';
export const SET_PASSED_LM_QUIZ = 'SET_PASSED_LM_QUIZ';
export const SET_PASSED_MM_QUIZ = 'SET_PASSED_MM_QUIZ';
export const SET_BADGE = 'SET_BADGE';
export const SET_WHOLE_GAMIFICATION = 'SET_WHOLE_GAMIFICATION';
